/* eslint-disable prettier/prettier */
import React from 'react';
import { Activity } from '../../types/schedule.types';
import {
	ACTIVITY_TYPE_MAP,
	MONTH_VISIBLE_ACTIVITIES_PER_DAY,
} from '../../constants/activitytypes.constant';
import { MONTHS_SHORT, isToday, toLocalTimeHM } from '../../utils/dateUtils';
import styles from '../../styles/Schedule/MonthDayCell.module.css';

interface MonthDayCellProps {
	date: Date;
	isCurrentMonth: boolean;
	activities: Activity[];
	onShowMore: (date: Date) => void;
	onActivityClick?: (activity: Activity) => void;
}

const MonthDayCell: React.FC<MonthDayCellProps> = ({
	date,
	isCurrentMonth,
	activities,
	onShowMore,
	onActivityClick,
}) => {
	const visible = activities.slice(0, MONTH_VISIBLE_ACTIVITIES_PER_DAY);
	const hiddenCount = activities.length - visible.length;

	return (
		<div
			className={[
				styles.cell,
				!isCurrentMonth ? styles.cellOther : '',
				isToday(date) ? styles.cellToday : '',
			].join(' ')}
		>
			<div className={styles.dateLabel}>
				<span className={styles.dateNum}>{date.getDate()}</span>
				<span className={styles.dateMonth}>
					{MONTHS_SHORT[date.getMonth()]}
				</span>
			</div>

			<div className={styles.activities}>
				{visible.map(activity => {
					const typeKey = activity.activitytype || activity.type;
					const config = typeKey
						? ACTIVITY_TYPE_MAP[typeKey]
						: undefined;
					const accent =
						activity.activitytypecolor ||
						config?.color ||
						'#6B7280';
					const bg = config?.bgColor || `${accent}1A`;

					return (
						<button
							key={activity.id}
							type="button"
							className={styles.activity}
							style={{
								background: bg,
								borderBottomColor: accent,
							}}
							onClick={() => onActivityClick?.(activity)}
							title={`${toLocalTimeHM(activity.startTime)}-${toLocalTimeHM(activity.endTime)} ${activity.title}`}
						>
							<span className={styles.time}>
								{toLocalTimeHM(activity.startTime)}-
								{toLocalTimeHM(activity.endTime)}
							</span>
							<span className={styles.title}>
								{activity.title}
							</span>
						</button>
					);
				})}

				{hiddenCount > 0 && (
					<button
						type="button"
						className={styles.moreBtn}
						onClick={() => onShowMore(date)}
						aria-label={`Show ${hiddenCount} more activities`}
					>
						+{hiddenCount}
					</button>
				)}
			</div>
		</div>
	);
};

export default MonthDayCell;
